import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Room from "@/pages/Room";
import OverlayRoom from "@/pages/OverlayRoom";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/room/:token/overlay" element={<OverlayRoom />} />
          <Route path="/room/:token" element={<Room />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors offset="32px" />
    </div>
  );
}

export default App;
